import { useLocation } from 'react-router-dom'
import { UserType } from '../../types'
import { objectToSnake } from '.'

export const useSegment = () => {
  const w = window as any
  const location = useLocation()

  const identify = async (user: UserType) => {
    try {
      if (!user) {
        return
      }

      const fullName = user.displayName || ''
      const firstAndLast = fullName.split(' ')

      const customerData = {
        name: user.displayName,
        firstName: firstAndLast[0] || '',
        lastName: firstAndLast.slice(1).join(' ') || '',
        user_id: user?.stripeCustomerId,
        email: user?.email,
        trial: user?.trial,
        has_trialed: user?.hasTrialed,
        last_request_at: new Date().getTime() / 1000,
        user_created_at: user?.createdAt?.seconds,
        stripe_subscription_status: user.stripeSubscriptionStatus,
        subscription_interval: user.subscriptionInterval,
        stripe_customer_id: user.stripeCustomerId,
        course: user.course
      }

      w.analytics.identify(user?.id, customerData)
    } catch (err) {}
  }

  const track = (eventName: string, properties?: any, options?: any) => {
    try {
      const props = {
        ...objectToSnake(properties),
        from: location.pathname,
        is_academy: true
      }

      w.analytics.track(eventName, props, options)

      w.Intercom('trackEvent', eventName, props)
    } catch (err) {}
  }

  const page = () => {
    w.analytics.page()
  }

  return { identify, track, page }
}
